// Retired with the 2026-10 redesign: the cosmic particle background is gone everywhere.
// Kept as a no-op so the pages that still import it keep compiling.
export function ConstellationBackground(): null {
  return null;
}

export default ConstellationBackground;
